import React, { Component } from 'react';
import LayoutPages from '../../Components/LayoutPages';
//import { Link } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Row, Col } from 'antd';
import packageJson from '../../../package.json';
import UserProvider from '../../js/userProvider';

import './Home.css';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {}
        this.menusOcultos = [];

        this.dadosProvider = UserProvider.getInstance();
    }

    componentWillMount(){
        this.menusOcultos = this.dadosProvider.getMenusOcultos();
    }


    render() {

        return (
            <LayoutPages pageTitle="Home" pageLocation={this.props.location} history={this.props.history} pageIndex="1">
                <div className="rowButtons">
                    
                    <Row gutter={16}>
                        {this.menusOcultos.indexOf(155) == -1 ?
                            <Col xs={{ span: 12}} lg={{ span: 6}} md={{ span: 6}} sm={{span: 12}}>
                                <Link to="/corridas-finalizadas">
                                    <Button type="primary" icon="check-circle-o">Corridas Finalizadas</Button>
                                </Link>
                            </Col>
                            :
                            <div></div>
                        }         
                        {this.menusOcultos.indexOf(156) == -1 ?
                            <Col xs={{ span: 12}} lg={{ span: 6}} md={{ span: 6}} sm={{span: 12}}>
                                <Link to="/rastrear-veiculos">
                                    <Button type="primary" icon="car">Rastrear Veiculo</Button>
                                </Link>
                            </Col>
                            :
                            <div></div>               
                        }   
                        {this.menusOcultos.indexOf(183) == -1 ?
                            <Col xs={{ span: 12}} lg={{ span: 6}} md={{ span: 6}} sm={{span: 12}}>
                                <Link to="/historico-pa">
                                    <Button type="primary" icon="unordered-list">Histórico de PA</Button>
                                </Link>
                            </Col>
                            :
                            <div></div>               
                        }    
                        {this.menusOcultos.indexOf(157) == -1 ?
                            <Col xs={{ span: 12 }} lg={{ span: 6}} md={{ span: 6}} sm={{span: 12}}>
                                <Link to="/minha-carteira">
                                    <Button type="primary" icon="wallet">Minha Carteira</Button>
                                </Link>
                            </Col>
                            :
                            <div></div>               
                        }
                        {this.menusOcultos.indexOf(158) == -1 ?
                            <Col xs={{ span: 12 }} lg={{ span: 6}}  md={{ span: 6}} sm={{span: 12}}>
                                <Link to="/perfil">
                                    <Button type="primary" icon="user">Perfil</Button>
                                </Link>
                            </Col>
                            :
                            <div></div>               
                        }      
                        {this.menusOcultos.indexOf(164) == -1 ?
                            <Col xs={{ span: 12 }} lg={{ span: 6}}  md={{ span: 6}} sm={{span: 12}}>
                                <Link to="/documentos">
                                    <Button type="primary" icon="file">Documentos</Button>
                                </Link>
                            </Col>
                            :
                            <div></div>               
                        }         
                        <Col hidden xs={{ span: 12}} lg={{ span: 6}} md={{ span: 6}} sm={{span: 12}}>
                            <Link to="/notificar-clientes">
                                <Button type="primary" icon="notification">Notificar clientes</Button>
                            </Link>
                        </Col>                    
                    </Row>
                </div>
                
            </LayoutPages>
        )
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/Pages/Home/Home.js